import { FC, HTMLProps } from 'react';

export const StonksIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      {...props}
    >
      <path
        d="M17.4 7L19.919 9.67167L14.551 15.365L10.151 10.6983L2 19.355L3.551 21L10.151 14L14.551 18.6667L21.481 11.3283L24 14V7H17.4Z"
        fill="#00B69B"
      />
    </svg>
  );
};
